module.exports = __webpack_public_path__ + "static/media/route-plus-sample-email.a5e50af6.jpg";